import React from 'react'
import { Orders } from '../components'
import { OrdersFilters } from '../components/OrdersFilters'

export const Dashboard: React.FC<any> = () => {
  return (
    <div className="flex flex-col h-full dashboard">
      <OrdersFilters />
      <Orders />
    </div>
  )
}
